import i18next from 'i18next';

i18next.addResources('es_CL', 'SettingsSidebar', {
  config: 'Configuración',
  autoAcceptOrders: 'Auto-aceptar pedidos',
  automaticDelivery: 'Delivery automático',
  deliveryTimes: 'Tiempo de entrega',
  print: 'Impresoras',
  printHelp: '¿Necesitas ayuda?',
  enabled: 'Habilitado',
  disabled: 'Deshabilitado',
  minutes: 'Minutos',
  deliveryReassignment: 'Reasignación de delivery automático'
});

i18next.addResources('es_CR', 'SettingsSidebar', {
  config: 'Configuración',
  autoAcceptOrders: 'Auto-aceptar pedidos',
  automaticDelivery: 'Delivery automáticoSSSS',
  deliveryTimes: 'Tiempo de entrega',
  print: 'Impresoras',
  printHelp: '¿Necesitas ayuda?',
  enabled: 'Habilitado',
  disabled: 'Deshabilitado',
  minutes: 'Minutos',
  deliveryReassignment: 'Reasignación de delivery automático'
});
